/* eslint-disable max-len */
export const CLD_RESOURCES_ROOT = 'https://res.cloudinary.com/';
export const MEDIA_EDITOR_DOCUMENTATION_URL = 'https://cloudinary.com/documentation/media_editor';
export const SIGN_UP_URL = 'https://cloudinary.com/users/register/free';
